import ddt from '@wix/da-ddt';
import { toJsonString } from './utils';
import { AdProviders, ADUNIT_IDS } from './constants';
import NitroAds from './providers/NitroAds';
class DaAds {
    // Special init for SSR where we noop the client only parts
    initSSR(providers) {
        this.init(providers, ()=>Promise.resolve(), []);
        return this;
    }
    // Init for the client
    init(providers, biLogger, activeUnits) {
        ddt.log('ads', 'Init', providers);
        this.biLogger = biLogger;
        this.activeUnits = activeUnits;
        for (const provider of providers){
            const inst = this.factoryProvider(provider);
            if (inst) {
                inst.init(this.biLogger);
                this.activeProviders[provider] = inst;
            }
        }
        this.providersReady = true;
        if (this.registerQueue.length > 0) {
            ddt.log('ads', 'Process Queue');
            this.registerQueue.map((q)=>q());
            this.registerQueue = [];
        }
    }
    registerUnit(provider, unitId, options) {
        // Skip already registered units, happens a lot because SSR
        if (this.activeUnits.includes(unitId)) {
            ddt.log('ads', 'Skip ads', provider, unitId, options);
            return;
        }
        ddt.log('ads', 'Register Unit', provider, unitId, options, this);
        if (!this.providersReady) {
            ddt.log('ads', 'Queuing register request', provider, unitId, options);
            let resolve;
            const promisedRegister = new Promise((r)=>{
                resolve = ()=>{
                    r(this.registerUnit(provider, unitId, options));
                };
            });
            this.registerQueue.push(resolve);
            return promisedRegister;
        }
        if (!this.activeProviders[provider]) {
            ddt.alert('ads', 'Tried to register ad for inactive provider', [
                'ads'
            ], {
                provider,
                options
            });
            return;
        }
        if (!ADUNIT_IDS.includes(unitId)) {
            ddt.alert('ads', 'Tried to register unknown adunit', [
                'ads'
            ], {
                provider,
                unitId,
                options
            });
            return;
        }
        try {
            this.activeProviders[provider].registerUnit(unitId, options);
            this.activeUnits.push(unitId);
        } catch (e) {
            ddt.alert('ads', 'Error from unit registration', [
                'ads'
            ], {
                provider,
                unitId,
                options,
                e
            });
        }
    }
    killUnit(unitId) {
        for (const key of Object.keys(this.activeProviders)){
            this.activeProviders[key].killUnit(unitId);
        }
        this.activeUnits = this.activeUnits.filter((u)=>u !== unitId);
    }
    getSSRAdUnits() {
        let output = `window.__ADUNITS__ = JSON.parse(${toJsonString(this.activeUnits)});\n`;
        for (const key of Object.keys(this.activeProviders)){
            if (this.activeProviders[key].toSSR) {
                output = `${output}${this.activeProviders[key].toSSR()}`;
            }
        }
        return output;
    }
    factoryProvider(provider) {
        switch(provider){
            case AdProviders.Nitro:
                return new NitroAds();
            default:
                ddt.alert('ads', 'Tried to init bad provider', [
                    'ads'
                ], provider);
                return false;
        }
    }
    constructor(){
        this.activeProviders = {};
        this.activeUnits = [];
        this.providersReady = false;
        this.registerQueue = [];
    }
}
export default DaAds;
